import { RouterLink } from '@/components'
import { routes } from '@/router'
import {
  useMediaQuery,
  Theme,
  Box,
  Card,
  Typography,
  SvgIcon,
} from '@mui/material'
import LogoReceitaFederal from '@/assets/images/logo-receita-federal.svg?react'

export function Taxes() {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))

  if (isMobile) {
    return (
      <RouterLink to={routes.accounting.taxes}>
        <Card>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontSize={18}>Impostos</Typography>
            <SvgIcon
              component={LogoReceitaFederal}
              inheritViewBox
              sx={{ color: 'secondary.main', fontSize: 32 }}
            />
          </Box>
        </Card>
      </RouterLink>
    )
  }

  return (
    <Card>
      <Typography fontSize={20} mb={2}>
        Impostos
      </Typography>

      <Typography color="textDisabled" py={3} textAlign="center">
        Você não possui pendências
      </Typography>
    </Card>
  )
}
